import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import {
  WORKED_STATUS_REDIRECTION_LINK,
  WORKED_STATUS_REDIRECTION_STATUS,
} from "@/Constants/common";
import { toggleOurServiceModal } from "@/reducers/clientcommon";
import { getWorkedStatusClasses } from "@/utilities/utils";

const WorkedStatusButton = ({
  timesheet_status,
  btnClass,
  contract_ref_no,
}) => {
  const dispatch = useDispatch();
  const { isPremiumAccount } = useSelector((state) => state.session);
  const isPremiumAccountPage =
    timesheet_status == "Terminated" || timesheet_status == "Rejected";
  return timesheet_status ? (
    WORKED_STATUS_REDIRECTION_STATUS.includes(timesheet_status) ? (
      <Link
        to={
          isPremiumAccountPage && !isPremiumAccount
            ? "#"
            : WORKED_STATUS_REDIRECTION_LINK[timesheet_status]
        }
        state={{
          contractReferenceNo: contract_ref_no,
        }}
        className={`${btnClass} ${getWorkedStatusClasses(timesheet_status)}`}
        onClick={(e) => {
          if (isPremiumAccountPage) {
            if (!isPremiumAccount) {
              e.preventDefault();
              dispatch(toggleOurServiceModal(true));
              // showManagedServiceToast();
            }
          }
        }}
      >
        {timesheet_status || "-"}
      </Link>
    ) : (
      <span
        className={`${btnClass} ${getWorkedStatusClasses(timesheet_status)}`}
      >
        {timesheet_status || "-"}
      </span>
    )
  ) : null;
};

export default WorkedStatusButton;
